import React from 'react';
import Text from "./Text";
import colors from "../utils/colors";


const NoInternetConnection = () => {
	const fontStyle = {fontSize: 14, color: colors.black};

	return (
		<div style={style}>
			<div>
				<Text style={fontStyle}>
					Không có kết nối mạng!
				</Text>
			</div>
			{/*<Button onPress={() => ZaloPay.showNoInternetConnection()}>*/}
			{/*	<Text style={{...fontStyle, ...{color: "#d0872e", marginLeft: 2}}}>*/}
			{/*		Kiểm tra kết nối*/}
			{/*	</Text>*/}
			{/*</Button>*/}
		</div>
	)
}
const style = {
	display: 'flex',
	backgroundColor: "#fffec4",
	height: 30,
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	border: `0.7px solid ${colors.border}`,
	zIndex: 2,
	width: '100%',
};

export default NoInternetConnection